import LockDeskService from '../services/lockDesk.service';
// import moment from 'moment';

export const lockDesk = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getLockDeskVM({ commit }, id){
      return LockDeskService.getLockDeskVM(id).then(
        resp => {
          commit('dummyConsole', "getLockDeskVM - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getLockDeskVM - error");
          return Promise.reject(error);
        }
      );
    },

    getLockPipeline({ commit }){
      return LockDeskService.getLockPipeline().then(
        lockRates => {
          commit('dummyConsole', "getLockPipeline - success");
          return Promise.resolve(lockRates);
        },
        error => {
          commit('dummyConsole', "getLockPipeline - error");
          return Promise.reject(error);
        }
      );
    },

    getLockInAgreement({ commit }, {confirmLock}) {
      return LockDeskService.getLockInAgreement(confirmLock).then(
        resp => {
          commit('dummyConsole', "getLockInAgreement - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getLockInAgreement - error");
          return Promise.reject(error.response);
        }
      );
    },    

    acceptLock({ commit }, {confirmLock}) {
      return LockDeskService.acceptLock(confirmLock).then(
        resp => {
          commit('dummyConsole', "acceptLock - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "acceptLock - error");
          return Promise.reject(error.response);
        }
      );
    },

    repricingLockAndSave({ commit }, {confirmLock}) {
      return LockDeskService.repricingLockAndSave(confirmLock).then(
        resp => {
          commit('dummyConsole', "repricingLockAndSave - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "repricingLockAndSave - error");
          return Promise.reject(error.response);
        }
      );
    },

    getFileScenario({ commit }, { loanNumber, selectedCompPlanID}){
      return LockDeskService.getFileScenario(loanNumber, selectedCompPlanID).then(
        resp => {
          commit('dummyConsole', "getFileScenario - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getFileScenario - error");
          return Promise.reject(error);
        }
      );
    },

    updateStatusLockedFile({ commit }, {loanNumber, status, lockDeskId}){
      return LockDeskService.updateStatusLockedFile(loanNumber, status, lockDeskId).then(
        resp => {
          commit('dummyConsole', "updateStatusLockedFile - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "updateStatusLockedFile - error");
          return Promise.reject(error.response);
        }
      );
    },

    compareLockInformation({ commit }, {loanNumber}){
      return LockDeskService.compareLockInformation(loanNumber).then(
        resp => {
          commit('dummyConsole', "compareLockInformation - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "compareLockInformation - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    }
  }
};